<template>
  <div class="thread_ads_training">
    <div class="row">
      <div class="col-lg-7 col-md-12 col-sm-12 col-xs-12 col-custom-1">
        <p class="thread-training">THREAD Training</p>
        <p class="thread-essentials pb-15">
          Learn the essentials in utilizing the THREAD Platform as well as insights into DCT best practices and key strategies.
        </p>
      </div>
      <div class="col-lg-5 col-md-12 col-sm-12 col-xs-12 btn-align col-custom-1">
        <!--  <button type="button" class="btn launch-thread-training-site">
                  Launch THREAD Training Site
                </button> -->
        <button type="button" class="btn coming-soon-button">
          Coming Soon
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "thread-material-dashboard",
  data() {
    return {};
  }
};
</script>

<style scoped lang="scss">
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-xs-1,
.col-xs-2,
.col-xs-3,
.col-xs-4,
.col-xs-5,
.col-xs-6,
.col-xs-7,
.col-xs-8,
.col-xs-9,
.col-xs-10,
.col-xs-11,
.col-xs-12 {
  padding: 0px;
}
.btn-align {
  text-align: center;
}
.coming-soon-button {
  margin-top: 44px;
  width: 200px;
  height: 38.7px;
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #b0bac9;
  font-family: "RobotoBold";
  font-size: 13px;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: center;
  color: #ffffff;
}

// Thread Training
.thread_ads_training {
  height: auto;
  margin: 6px 11px 16.5px 19.9px;
  border-radius: 4px;
  border: solid 1px #c5d1d6;
  background-color: #34537d;
}
.thread-training {
  height: 16px;
  margin: 15px 0px 12.1px 18px;
  font-family: "RobotoBold";
  font-size: 14px;
  text-align: left;
  color: #ffffff;
}
.thread-essentials {
  width: auto;
  height: auto;
  margin: 14.5px 24.5px 0 17px;
  font-family: "RobotoRegular";
  font-size: 13px;
  line-height: 1.29;
  text-align: left;
  color: #ffffff;
}
.launch-thread-training-site {
  width: 208px;
  // height: 33.7px;
  // margin: 44.5px 0px 10.3px 37.3px;
  position: absolute;
  right: 21px;
  top: 44px;
  font-family: "RobotoBold";
  font-size: 13px;
  -webkit-box-shadow: none;
  box-shadow: none;
  text-align: center;
  color: #ffffff;
  background-color: #4c8ce4;
}
@media (max-width: 1152px) {
  .launch-thread-training-site {
    width: 158px;
    position: absolute;
    right: 11px;
    top: 34px;
    font-family: "RobotoBold";
    font-size: 11px;
    -webkit-box-shadow: none;
    box-shadow: none;
    text-align: center;
    color: #ffffff;
    background-color: #4c8ce4;
  }
}
@media (min-width: 320px) and (max-width: 768px) {
  .coming-soon-button {
    margin: 10px 17px 17px;
  }
  .btn-align {
    text-align: left;
  }
}
</style>
